import { ISpacesSate } from "@/services/store/modules/spaces/spaces-types";

export const state: ISpacesSate = {
  spaces: {},
  loading: false,
  error: null,
};
